function PointMissionsSortHeader({ sortType, sortField, onSortChange }) {
  const sortRow = [
    {
      field: "title",
      type: "asc",
      label: "Name",
      width: "md:w-[60%]",
    },
    {
      field: "pointsRewarded",
      type: "asc",
      label: "Point",
      width: "md:w-[10%]",
    },
    {
      field: "type",
      type: "asc",
      label: "Type",
      width: "md:w-[20%]",
    },
    {
      field: "isActive",
      type: "asc",
      label: "State",
      width: "md:w-[12%]",
    },
    {
      field: "createdAt",
      type: "asc",
      label: "Date Created",
      width: "md:w-[20%]",
    },
    {
      field: "name",
      type: "filler",
      label: "Name",
      width: "md:w-[5%]",
    },
  ];

  const selectSortHeader = (index) => {
    const sort = sortRow[index];
    console.log({ sort });
    if (sort.type === "filler") return;
    if (sort.field !== sortField) {
      onSortChange({
        orderBy: sort.field,
        order: "asc",
      });
      return;
    } else {
      onSortChange({
        orderBy: sort.field,
        order: sortType === "asc" ? "desc" : "asc",
      });
    }
  };

  // console.log({ sortType, sortField });

  return (
    <div className="w-full hidden md:flex flex-col pt-4">
      <div className="flex items-center gap-1 justify-between w-full ">
        {sortRow.map(({ width, type, field, label }, index) => (
          <div
            key={index}
            onClick={() => {
              if (type !== "filler") selectSortHeader(index);
            }}
            className={`h-12 overflow-hidden ${
              width || "flex flex-1"
            } py-[1px]  first:rounded-ss-lg last:rounded-se-lg ${
              sortField === field
                ? "border border-[#B8D1FF] bg-[#B2CDFF]"
                : "bg-[#DCE8FF]"
            }`}
          >
            <div
              className={`h-full w-full flex items-center justify-between px-4 text-xs cursor-pointer font-bold text-[#2E2E32] bg-[#B6CDF9]`}
            >
              {/* <span></span> */}
              <span>{type !== "filler" ? label : ""}</span>
              <span>
                {/* <img src="/arrowDown.svg" alt="" /> */}
                {sortField === field && type !== "filler" && (
                  <>
                    {sortType === "asc" ? (
                      <img src="/arrowDown.svg" alt="" />
                    ) : (
                      <img src="/arrowUp.svg" alt="" />
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PointMissionsSortHeader;
